{
  "common": {
    "login": "Se connecter",
    "submit": "Soumettre",
    "error": "Erreur"
  },
  "vault": {
    "title": "Voûte de documents sécurisée",
    "description": "Téléversez vos documents en toute sécurité.",
    "success": "Succès !",
    "successMessage": "Vos fichiers ont été téléversés avec succès"
  },
  "login": {
    "email": "Courriel",
    "code": "Code",
    "continue": "Connectez-vous pour continuer",
    "input": "Veuillez saisir votre courriel pour vous connecter.",
    "receive": "Un code vous sera envoyé par courriel pour confirmer votre identité.",
    "inputCode": "Saisissez le code pour continuer",
    "receiveCode": "Veuillez saisir le code que vous avez reçu par courriel.",
    "tooManyRequests": "Trop de requêtes",
    "pleaseTryAgainLater": "Veuillez patienter avant de demander un nouveau code.",
    "errorOccurred": "Une erreur s'est produite lors de l'envoi du code."
  },
  "user": {
    "firstName": "Prénom",
    "lastName": "Nom",
    "email": "Courriel",
    "message": "Message"
  },
  "files": {
    "name": "Nom",
    "size": "Taille",
    "date": "Date",
    "actions": "Actions"
  },
  "upload": {
    "drag": "Glissez et déposez vos fichiers ici ou cliquez pour sélectionner des fichiers",
    "attach": "Joignez autant de fichiers que vous le souhaitez, jusqu'à 1 Go chacun"
  },
  "footer": {
    "unicorne": "© 2024 Unicorne",
    "politics": "Politique de confidentialité",
    "conditions": "Conditions d'utilisation"
  }
}
